module.exports = __webpack_public_path__ + "assets/img/16.fc7a9d8a.png";